/* tslint:disable */
/* eslint-disable */
/**
 * Lightly API
 * Lightly.ai enables you to do self-supervised learning in an easy and intuitive way. The lightly.ai OpenAPI spec defines how one can interact with our REST API to unleash the full potential of lightly.ai
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@lightly.ai
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// SRC: https://github.com/OpenAPITools/openapi-generator/blob/master/modules/openapi-generator/src/main/resources/typescript-fetch/modelGeneric.mustache
// synched 02.02.2023
import * as yup from 'yup';
import typia from 'typia';
import * as fastJSON from 'fast-json-stringify';
import { Options, ArraySchema, ObjectSchema } from 'fast-json-stringify';
import { exists, mapValues } from '../runtime';
import type { DockerRunScheduledState } from './DockerRunScheduledState';
import { DockerRunScheduledStateFromJSON, DockerRunScheduledStateFromJSONTyped, DockerRunScheduledStateToJSON, } from './DockerRunScheduledState';
/*
causes circular dependendies
*/
// SRC: https://github.com/OpenAPITools/openapi-generator/blob/master/modules/openapi-generator/src/main/resources/typescript-fetch/modelGenericInterfaces.mustache
// synced: 17.07.2023
/**
 *
 * @export
 * @interface DockerRunScheduledStateArray
 *
 */
// create custom validators for the regexes
export interface DockerRunScheduledStateArray extends Array<DockerRunScheduledState> {
}
/**
 * Check if a given object implements the DockerRunScheduledStateArray interface.
 */
export function instanceOfDockerRunScheduledStateArray(value: object): boolean {
    let isInstance = true;
    return isInstance;
}
/* LIGHTLY CUSTOM START -> modelGeneric */
import { DockerRunScheduledStateValidator, DockerRunScheduledStateStringifyShape, DockerRunScheduledStateStringifyShapeProperties, } from './DockerRunScheduledState';
export const DockerRunScheduledStateArrayTypiaAssertEquals = (input: any) => {
    return ((input: any): DockerRunScheduledStateArray => {
        const __is = (input: any, _exceptionable: boolean = true): input is DockerRunScheduledStateArray => {
            const $join = (typia.createAssertEquals as any).join;
            const $io0 = (input: any, _exceptionable: boolean = true): boolean => "number" === typeof input.length && Object.keys(input).every((key: any) => {
                if (["length"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                if (RegExp(/^[+-]?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?$/).test(key))
                    return "OPEN" === value || "LOCKED" === value || "DONE" === value || "CANCELED" === value;
                return false;
            });
            return "object" === typeof input && null !== input && $io0(input, true);
        };
        if (false === __is(input))
            ((input: any, _path: string, _exceptionable: boolean = true): input is DockerRunScheduledStateArray => {
                const $guard = (typia.createAssertEquals as any).guard;
                const $join = (typia.createAssertEquals as any).join;
                const $ao0 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("number" === typeof input.length || $guard(_exceptionable, {
                    path: _path + ".length",
                    expected: "number",
                    value: input.length
                })) && (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["length"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    if (RegExp(/^[+-]?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?$/).test(key))
                        return "OPEN" === value || "LOCKED" === value || "DONE" === value || "CANCELED" === value || $guard(_exceptionable, {
                            path: _path + $join(key),
                            expected: "(\"CANCELED\" | \"DONE\" | \"LOCKED\" | \"OPEN\")",
                            value: value
                        });
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                }));
                return ("object" === typeof input && null !== input || $guard(true, {
                    path: _path + "",
                    expected: "DockerRunScheduledStateArray",
                    value: input
                })) && $ao0(input, _path + "", true) || $guard(true, {
                    path: _path + "",
                    expected: "DockerRunScheduledStateArray",
                    value: input
                });
            })(input, "$input", true);
        return input;
    })(input);
};
export const DockerRunScheduledStateArrayTypiaAssertStringify = (input: DockerRunScheduledStateArray): string => {
    return ((input: any): string => { const assert = (input: any): DockerRunScheduledStateArray => {
        const __is = (input: any): input is DockerRunScheduledStateArray => {
            const $join = (typia.createAssertStringify as any).join;
            const $io0 = (input: any): boolean => "number" === typeof input.length && !Number.isNaN(input.length) && Object.keys(input).every((key: any) => {
                if (["length"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                if (RegExp(/^[+-]?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?$/).test(key))
                    return "OPEN" === value || "LOCKED" === value || "DONE" === value || "CANCELED" === value;
                return true;
            });
            return "object" === typeof input && null !== input && $io0(input);
        };
        if (false === __is(input))
            ((input: any, _path: string, _exceptionable: boolean = true): input is DockerRunScheduledStateArray => {
                const $guard = (typia.createAssertStringify as any).guard;
                const $join = (typia.createAssertStringify as any).join;
                const $ao0 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("number" === typeof input.length && !Number.isNaN(input.length) || $guard(_exceptionable, {
                    path: _path + ".length",
                    expected: "number",
                    value: input.length
                })) && (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["length"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    if (RegExp(/^[+-]?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?$/).test(key))
                        return "OPEN" === value || "LOCKED" === value || "DONE" === value || "CANCELED" === value || $guard(_exceptionable, {
                            path: _path + $join(key),
                            expected: "(\"CANCELED\" | \"DONE\" | \"LOCKED\" | \"OPEN\")",
                            value: value
                        });
                    return true;
                }));
                return ("object" === typeof input && null !== input || $guard(true, {
                    path: _path + "",
                    expected: "DockerRunScheduledStateArray",
                    value: input
                })) && $ao0(input, _path + "", true) || $guard(true, {
                    path: _path + "",
                    expected: "DockerRunScheduledStateArray",
                    value: input
                });
            })(input, "$input", true);
        return input;
    }; const stringify = (input: DockerRunScheduledStateArray): string => {
        const $join = (typia.createAssertStringify as any).join;
        const $string = (typia.createAssertStringify as any).string;
        const $throws = (typia.createAssertStringify as any).throws;
        const $tail = (typia.createAssertStringify as any).tail;
        const $so0 = (input: any): any => `{${$tail(`"length":${input.length},${Object.entries(input).map(([key, value]: [string, any]) => { if (undefined === value)
            return ""; if (["length"].some((regular: any) => regular === key))
            return ""; if (RegExp(/^[+-]?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?$/).test(key))
            return `${JSON.stringify(key)}:${(() => {
                if ("string" === typeof value)
                    return $string(value);
                if ("string" === typeof value)
                    return "\"" + value + "\"";
                $throws({
                    expected: "(\"CANCELED\" | \"DONE\" | \"LOCKED\" | \"OPEN\")",
                    value: value
                });
            })()}`; return ""; }).filter((str: any) => "" !== str).join(",")}`)}}`;
        return $so0(input);
    }; return stringify(assert(input)); })(input);
};
export const DockerRunScheduledStateArrayValidatorShape = {};
export const DockerRunScheduledStateArrayValidator = yup.array().of(DockerRunScheduledStateValidator);
export const DockerRunScheduledStateArrayStringifyShapeProperties: ObjectSchema['properties'] = {};
export const DockerRunScheduledStateArrayStringifyShape: ArraySchema = {
    title: 'DockerRunScheduledStateArray Stringifier',
    type: 'array',
    items: DockerRunScheduledStateStringifyShape
};
export const DockerRunScheduledStateArrayStringifyCompiled = (typeof process === 'object' && String(process) === '[object process]') ?
    fastJSON.build(DockerRunScheduledStateArrayStringifyShape, {
        ajv: {
            // since we are already doing this with yup, lets skip
            validateSchema: false,
            ownProperties: true,
            validateFormats: false,
        },
        largeArrayMechanism: 'json-stringify',
        largeArraySize: 1000,
    } as Options)
    :
        () => { throw new Error('fast-json-stringify only works in nodejs'); };
export const DockerRunScheduledStateArrayStringify: (data: DockerRunScheduledStateArray) => string = DockerRunScheduledStateArrayStringifyCompiled;
/* LIGHTLY CUSTOM END -> Generic */
export function DockerRunScheduledStateArrayFromJSON(json: any): DockerRunScheduledStateArray {
    return DockerRunScheduledStateArrayFromJSONTyped(json, false);
}
export function DockerRunScheduledStateArrayFromJSONTyped(json: any, ignoreDiscriminator: boolean): DockerRunScheduledStateArray {
    return json;
}
export function DockerRunScheduledStateArrayToJSON(value?: DockerRunScheduledStateArray | null): any {
    return value;
}
